import React, { useEffect } from 'react';
import { Route, withRouter } from 'react-router-dom';
import Switch from 'react-router-dom/Switch';
import PropTypes from 'prop-types';

import PricingSummary from './pages';

const PricingRouter = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <Switch>
      <Route path="/pricing" component={PricingSummary} />
      <Route
        path="/pricing/:packageTypes(teams|individual)"
        component={PricingSummary}
      />
    </Switch>
  );
};

PricingRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(PricingRouter);
